<template>
  <div>
    <BaseHeader title="ダッシュボード" />
    <div class="dashboard-block">
      <NoticeTable
          v-if="$isFunctionShown(define.PermissionKeys.Dashboard.CUSTOMER_ALERT)"
          :type="2" />
    </div>

    <div class="dashboard-block">
      <NoticeTable
          v-if="$isFunctionShown(define.PermissionKeys.Dashboard.INFORMATION)"
          :type="1" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as define from '@/define'
import BaseHeader from '@/components/molecules/BaseHeader'
import NoticeTable from '@/components/pages/dashboard/NoticeTable'

export default {
  name: 'DashBoard',
  components: {
    BaseHeader,
    NoticeTable
  },
  data () {
    return {
      siteGroups: [],
      brandGroups: [],
      orderGroups: [],
      selectedGroup1: null,
      selectedGroup2: null,
      selectedGroup3: null,
      selectedGroup4: '',
      selectedGroup5: '',
      isHide: true,
      isHide2: true,
      isHide3: true,
      isHide4: true,
      isHide5: true,
      isHide6: true,
      isHide7: true
    }
  },
  computed: {
    define: () => define,
    ...mapState({
    })
  },
  watch: {
  },
  created () {
    this.siteGroups = this.getSiteGroups()
    this.brandGroups = this.getBrandGroups()
    this.orderGroups = this.getOrderGroups()
  },
  beforeUpdate () {
  },
  mounted () {
  },
  methods: {
    getSiteGroups () {
      return [
        { code: 1, name: 'サイトA' },
        { code: 2, name: 'サイトB' },
        { code: 3, name: 'サイトC' }
      ]
    },
    getBrandGroups () {
      return [
        { code: 1, name: 'ブランドA' },
        { code: 2, name: 'ブランドB' },
        { code: 3, name: 'ブランドC' }
      ]
    },
    getOrderGroups () {
      return [
        { code: 1, name: '日別A' },
        { code: 2, name: '日別B' },
        { code: 3, name: '日別C' }
      ]
    },
    onGroupChanged (event) {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/DashBoardTop.vue